import { ApplicationInsights, IApplicationInsights } from "@microsoft/applicationinsights-web";
import { InjectionToken } from "@angular/core";

export type IPcpApplicationInsights = Pick<IApplicationInsights,
    'addTelemetryInitializer'
    |'trackException'
    |'trackEvent'
    |'trackMetric'
    |'trackTrace'
    |'trackDependencyData'
    |'trackPageView'
    |'trackPageViewPerformance'
    |'startTrackEvent'
    |'startTrackPage'
    |'stopTrackEvent'
    |'stopTrackPage'

    |'setAuthenticatedUserContext'
    |'clearAuthenticatedUserContext'
    |'context'
>;

export const PcpApplicationInsights = new InjectionToken<IPcpApplicationInsights>('PCP_APPLICATION_INSIGHTS');
